import { LogType, LogsRow } from '@components/logsScreen';
import { Typography } from '@components/typography';
import { GetPreviewLogQueryResult, Preview, useGetPreviewLogLazyQuery } from '@generated/graphql';
import { Box, Stack, useTheme } from '@mui/material';
import { useCurrentWorkspaceId } from '@navigation/WorkspaceContext';
import { useEffect, useState } from 'react';
import { Virtuoso } from 'react-virtuoso';

const renderVerticalLogRow = (_index: number, log: LogType) => (
  <LogsRow log={log} variant="vertical" />
);

export const GraphPreviewLogs = ({ preview }: { preview: Partial<Preview> }) => {
  const { palette } = useTheme();
  const workspaceId = useCurrentWorkspaceId();
  const [logs, setLogs] = useState<LogType[]>([]);
  const [logsLoading, setLogsLoading] = useState(true);
  const [getPreviewLogs] = useGetPreviewLogLazyQuery();

  useEffect(() => {
    if (!['failed', 'success'].includes(preview?.status)) {
      return;
    }
    setLogsLoading(true);
    getPreviewLogs({ variables: { workspaceId, previewId: preview?.previewId } })
      .then((result: GetPreviewLogQueryResult) => {
        if (result?.data?.getPreviewLog?.log) {
          setLogs((JSON.parse(result.data.getPreviewLog.log) as LogType[]) || []);
          setLogsLoading(false);
        }
      })
      .catch((e) => {
        console.error(e);
        setLogsLoading(false);
      });
  }, [preview, getPreviewLogs, workspaceId]);

  if (!logsLoading && (!logs || logs.length === 0)) {
    return (
      <Stack height="100%" width="100%" justifyContent="center" alignItems="center">
        <Typography>No logs found</Typography>
      </Stack>
    );
  }
  return (
    <Box flex={1} width="100%" minHeight={0} sx={{ border: `1px solid ${palette.grey[700]}` }}>
      <Virtuoso data={logs} itemContent={renderVerticalLogRow} style={{ height: '100%' }} />
    </Box>
  );
};
